"use client";

import { Text, Flex, Spacing } from "@huub-web/ui";

import { slideHeadingDescriptionStyle } from "./BaseSlide.css";

type SlideHeadingProps = {
  title: string;
  description?: string;
};

/**
 * Reusable slide heading component for the mortgage wizard
 * Provides consistent styling and layout for slide titles and descriptions
 */
export const SlideHeading = ({ title, description }: SlideHeadingProps) => (
  <Flex direction="column" gap="s">
    <Text variant="displayM" bold>
      {title}
    </Text>
    {description && (
      <Text className={slideHeadingDescriptionStyle}>{description}</Text>
    )}
    <Spacing />
  </Flex>
);
